import recommendationsModule from '../recommendationsModule.js';

const recommendationsConstants = {
  recommendationTypes: {
    asset: 0,
    bundle: 2 // TODO: FOR ROLLOUT FALLBACK, WILL REMOVE IT AFTER ALL CHANGES ARE OUT
  },
  recommendationSubtypes: {
    gamePasses: 21,
    badges: 34
  },
  urls: {
    catalog: '/catalog'
  },
  pageNames: {
    avatar: 'Avatar',
    catalogItem: 'CatalogItem',
    bundleDetails: 'BundleDetail',
    inventory: 'Inventory',
    favorites: 'Favorites'
  },
  carouselSelector: '#recommendation-carousel-container'
};

recommendationsModule.constant('recommendationsConstants', recommendationsConstants);
export default recommendationsConstants;
